// extracted by mini-css-extract-plugin
export default {"devices-activation-button":"DevicesActivationButton_devices-activation-button__ArjB+"};